export function DayFilter(){
    return function(elements, day) {
        const filtered = [];

        if (elements){
            for (let i = 0; i < elements.length; i++) {
              if (moment(elements[i].date).day() == day) {
                filtered.push(elements[i]);
              }
            }
        }
        return filtered;
        };
}
